export const renderWebsite = (param) => {
  if (param) {
    return param.replace('http://','').replace('https://','').replace('www.','').split(/[/?#]/)[0];
  }
  return "";
};
